// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox-module__wrapper","input":"Checkbox-module__input","content":"Checkbox-module__content"};